/**
 * ShopSalesColumns Component
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 15 화요일
 * 마지막 수정일 - 2025 07 15 화요일
 */
import { Checkbox } from 'antd';

const ShopSalesColumns = (props) => {
  /**
   * SECTION - Props
   */
  const { columns = [], checked = [], onChange = () => {} } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Render
   */
  return (
    <Checkbox.Group
      value={checked}
      onChange={onChange}
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        maxWidth: 1000,
      }}
    >
      {columns.map((item, index) => (
        <Checkbox
          key={`checkbox-${item.title}-${item.key}-${index}`}
          value={item.key}
        >
          {item.title}
        </Checkbox>
      ))}
    </Checkbox.Group>
  );
  /**!SECTION - Render */
};

export default ShopSalesColumns;
